import { Storage } from '@ionic/storage';
import { 
  KEY_AZURE_TOKEN, 
  KEY_ACCESS_TOKEN, 
  KEY_REFRESH_TOKEN 
} from '../Helpers/constant';

// Initialize Ionic Storage
const storage = new Storage();
storage.create();

// Storage service class
class StorageService {
  private storage: Storage;

  constructor() {
    this.storage = storage;
  }

  // Set item in storage
  async setItem(key: string, value: any): Promise<void> {
    try {
      await this.storage.set(key, value);
    } catch (error) {
      console.error('Error setting item in storage:', error);
      throw error;
    }
  }

  // Get item from storage
  async getItem(key: string): Promise<any> {
    try {
      const value = await this.storage.get(key);
      return value;
    } catch (error) {
      console.error('Error getting item from storage:', error);
      throw error;
    }
  }

  // Remove item from storage
  async removeItem(key: string): Promise<void> {
    try {
      await this.storage.remove(key);
    } catch (error) {
      console.error('Error removing item from storage:', error);
      throw error;
    }
  }

  // Clear all storage
  async clear(): Promise<void> {
    try {
      await this.storage.clear();
    } catch (error) {
      console.error('Error clearing storage:', error);
      throw error;
    }
  }

  // Get all keys
  async keys(): Promise<string[]> {
    try {
      return await this.storage.keys();
    } catch (error) {
      console.error('Error getting storage keys:', error);
      throw error;
    }
  }

  // Check if key exists
  async hasKey(key: string): Promise<boolean> {
    try {
      const value = await this.storage.get(key);
      return value !== null && value !== undefined;
    } catch (error) {
      console.error('Error checking key in storage:', error);
      throw error;
    }
  }
}

// Create and export a singleton instance
const storageService = new StorageService();

export default storageService; 